import { CSSProperties } from 'react';

export const LINE_CLAMP_STYLES: CSSProperties = {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
};
